<template>
    <div>
        <!-- 面包屑导航 -->
        <div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item class="mybread" :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item class="mybread">基本信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 第一行搜索框和新增按钮 -->
        <el-row type="flex"  class="myRow">
            <el-col :span="2">姓名:</el-col>
            <el-col :span="2">{{basicInfo.fullName}}</el-col>
            <el-col :span="2">学号:</el-col>
            <el-col :span="4">{{basicInfo.username}}</el-col>
            <el-col :span="2">班级:</el-col>
            <el-col :span="4">{{basicInfo.banji}}</el-col>
        </el-row>
       
        <!-- 得分列表-->
        <el-table border show-summary  :row-style="{ height: '30px' }"
            :data="scoreListDetail"
            :header-cell-style="{
			background: '#fff1f0', height: '60px', color: '#000000'
		}">
            :highlight-current-row='true'>
            <el-table-column type="index" label="序号" width="100px"> </el-table-column>
            <el-table-column prop="key" label="活动类型"  sortable width="250px">
            </el-table-column>
            <el-table-column prop="val" label="活动分数小计" width="300px">
            </el-table-column>

        </el-table>
    </div>
</template>

<script>
import { getUser, getActivityList,listUserWithScoreDetail } from "@/utils/api.js"
export default {
    data() {
        return {
            addForm: {
                date2: ''
            },
            scoreListDetail:[],
            queryInfo: {
                name: '',
                dateStart: '',
                dateEnd: '',
                createTimeStart: '',
                createTimeEnd: '',
                type: '',

            },
            basicInfo: {
                fullName: '',
                sex: '',
                minzu: '',
                mobile: '',
                username: '',

            },

            activityList: [],
            activityType: [
                {
                    value: "请选择",
                    label: "请选择",
                },
                {
                    value: "志愿服务活动",
                    label: "志愿服务活动",
                }, {
                    value: "文体艺术活动",
                    label: "文体艺术活动"
                }],
            addActiFormRules: {
                type: [{
                    required: true, message: "请选择活动类型"
                }],
                name: [{
                    required: true, message: "请填写活动名称"
                }],
                score: [{
                    required: true, message: "请填写活动分数"
                }],
                date: [{
                    required: true, message: "请填写活动日期"
                }],
            }

        }
    },
    created() {
        this.info();
       
    },
    methods: {
        //获取到当前登录信息
        info() {
            getUser().then(result => {
                if (result.code === '0000') {
                    this.basicInfo = result.data;
                    this.mylistUserWithScoreDetail(result.data.userId);
                }
            })
        },
      	//学生活动分数细则
		mylistUserWithScoreDetail(userId) {
			const param = { "userId": userId };
			listUserWithScoreDetail(param).then(result => {
				if (result.code === '0000') {
					this.scoreDetailVisible = true;
					let arr = [];
					arr = Object.keys(result.data).map(val => ({
						key: val,
						val: result.data[val]
					}))
					this.scoreListDetail = arr;

				} else {
					console.log(result)
				}
			})

		},
    }
}
</script>

<style>
.title {
    font-size: 20px;
}

.basicInfo {
    height: 300px;
    width: 500px;
    background-color: bisque;
}

.el-button--primary {
    background-color: darkred;
    color: #fff;
    border-color: darkred;
    width: 130px;
    font-size: 18px;
}

.el-button--primary:focus,
.el-button--primary:hover {
    background: yellow;
    border-color: #66b1ff;
    color: #FFF;
}

.el-upload {
    width: 100%;
}

.el-upload .el-upload-dragger {
    width: 100%;
}

.el-breadcrumb .el-breadcrumb__inner {
    color: grey;
    font-size: 18px;
}

.myRow {
    margin-top: 50px;
    margin-bottom: 30px;
    margin-left: 20px;
}

.el-table {
    overflow: visible !important;
}
</style>